import { useEffect, useState } from "react";
import { useApiGet } from "../../utils/api";
import { useModal } from "../../utils/modal_launcher";
import { LogActivityModal } from "./log_activity_modal";

const formatTime = (isoString: string): string => {
  return new Date(isoString).toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
  });
};

const timeAgo = (isoString: string): string => {
  const seconds = Math.floor(
    (Date.now() - new Date(isoString).getTime()) / 1000,
  );
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes} minute${minutes !== 1 ? "s" : ""} ago`;

  const remMinutes = minutes % 60;
  let result = `${hours}h ${remMinutes}m`;
  return result + " ago";
};

export const Dashboard = () => {
  const { data, unavailable, refetch } = useApiGet("/api/user/dashboard");
  const logActivityModal = useModal(LogActivityModal);
  const [, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setTick((t) => t + 1), 60000);
    return () => clearInterval(interval);
  }, []);

  if (unavailable) return unavailable;

  const lastFeeding = data?.last_feeding;
  const lastDiaperChange = data?.last_diaper_change;

  return (
    <div
      className="container py-4"
      style={{ position: "relative", minHeight: "87vh" }}
    >
      <div className="card border-0 shadow mb-4 bg-gray-3">
        <div className="card-body text-center py-5">
          <h6 className="text-muted text-uppercase mb-2">Last Feeding</h6>
          {lastFeeding ? (
            <>
              <div className="fs-90 fw-bold mb-3">
                {timeAgo(lastFeeding.ended_at)}
              </div>
              <div className="fs-48 gray-c fw-bold mb-4">
                at {formatTime(lastFeeding.ended_at)}
              </div>
            </>
          ) : (
            <p className="text-muted mb-4">No feedings logged yet</p>
          )}
          <button
            className="btn btn-primary fs-28 px-5"
            onClick={() => logActivityModal.show({ refetch, model: "feeding" })}
          >
            Add Feeding
          </button>
        </div>
      </div>

      <div className="card border-0 shadow-sm">
        <div className="card-body d-flex justify-content-between align-items-center py-3">
          <div>
            <div className="text-muted text-uppercase mb-2">
              Last Diaper Change
            </div>
            {lastDiaperChange ? (
              <p className="mb-0 fs-5">
                {timeAgo(lastDiaperChange.ended_at)}
                <span
                  className="text-muted ms-2"
                  style={{ fontSize: "0.85em" }}
                >
                  ({formatTime(lastDiaperChange.ended_at)})
                </span>
              </p>
            ) : (
              <p className="mb-0 fs-5 text-muted">None logged yet</p>
            )}
          </div>
          <button
            className="btn btn-outline-secondary"
            onClick={() =>
              logActivityModal.show({ refetch, model: "diaper_change" })
            }
          >
            Add Diaper Change
          </button>
        </div>
      </div>

      <button
        type="button"
        className="btn btn-text"
        style={{
          position: "fixed",
          right: 24,
          bottom: 24,
          zIndex: 100,
          borderRadius: "50%",
          width: 64,
          height: 64,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "2rem",
        }}
        aria-label="Refresh Dashboard"
        onClick={() => window.location.reload()}
      >
        &#x21bb;
      </button>
    </div>
  );
};
